import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const ViewInvoiceDetailsModal = ({
  open,
  handleClose,

  leadData,
}) => {
  console.log("Leads", leadData);
  const projectId = leadData?.projectData?.projectId;
  const wingId = leadData?.wingData?.wingId;
  const isAOP_POP =
    leadData?.BrokerageType === "AOP" ||
    leadData?.BrokerageType === "POP";
  console.log("projectId in view invoice modal---->", projectId);
  function formatIndianCurrency(amount) {
    if (!amount || isNaN(amount)) return "0";

    const roundedAmount = Math.round(parseFloat(amount)); // Round to nearest integer
    const amountStr = roundedAmount.toString();

    const lastThree = amountStr.substring(amountStr.length - 3);
    const otherNumbers = amountStr.substring(0, amountStr.length - 3);

    const formattedRupees =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      (otherNumbers ? "," : "") +
      lastThree;

    return formattedRupees;
  }

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: 3,
            borderRadius: 2,
            boxShadow: 24,
            minWidth: 300,
            maxWidth: 500,
            maxHeight: 600,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              color: "primary.main",
              fontSize: { xs: "3rem", sm: "1.75rem", md: "2rem" },
            }}
          >
            Invoice Details
          </Typography>

          {/* Company Name */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              <strong>Company Name</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              {leadData?.Company_Name || "NA"}
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              <strong>Company Registered Address</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              {leadData?.Company_Address || "NA"}
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              <strong>GSTIN Number</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              {leadData?.Company_GST || "NA"}
            </Typography>
          </Box>

          {/* 🔥 ONLY ADD THIS FLAG ABOVE */}
          {!(
            leadData?.BrokerageType === "AOP" ||
            leadData?.BrokerageType === "POP"
          ) && (
              <>
                {/* Agreement Value */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
                    <strong>Agreement Value</strong>
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
                    {leadData?.Agreement_Value
                      ? `₹ ${formatIndianCurrency(leadData.Agreement_Value)}`
                      : "NA"}
                  </Typography>
                </Box>

                {/* Brokerage % (YOUR EXISTING LOGIC SAME) */}
                {wingId === "f61a1b3a-fc89-43e9-86e2-bee61dc884dd" ? (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
                      <strong>Brokerage %</strong>
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
                      {leadData?.Brokerage_Persentage || "3"}%
                    </Typography>
                  </Box>
                ) : projectId !== "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" ? (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
                      <strong>Brokerage %</strong>
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
                      {leadData?.Brokerage_Persentage || "3"}%
                    </Typography>
                  </Box>
                ) : null}
              </>
            )}

          {/* Basic Brokerage amount (UNCHANGED) */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              <strong>Basic Brokerage Amount</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" } }}>
              {leadData?.Brokerage_Amount_Basic
                ? `₹ ${formatIndianCurrency(leadData.Brokerage_Amount_Basic)}`
                : "NA"}
            </Typography>
          </Box>
          {/* {projectId !== "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077"  (
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                  fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" },
                }}
              >
                <strong>Brokerage %</strong>
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" },
                }}
              >
                {leadData?.Brokerage_Persentage || "3"}%
              </Typography>
            </Box>
          )}

         
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                  fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" },
                }}
              >
                <strong> Basic Brokerage Amount</strong>
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" },
                }}
              >
                {leadData?.Brokerage_Amount_Basic
                  ? `₹ ${formatIndianCurrency(leadData.Brokerage_Amount_Basic)}`
                  : "NA"}
              </Typography>
            </Box>
           */}

          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              marginTop: 2,
              width: "100%",
              padding: "10px",
              fontSize: { xs: "2.1rem", sm: "1rem", md: "1.5rem" },
              textTransform: "none",
            }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default ViewInvoiceDetailsModal;
